/**
 * Lazy-load reCAPTCHA v3 only on pages that actually need it.
 *
 * If REACT_APP_RECAPTCHA_SITE_KEY isn't set, the helper resolves to null and
 * the backend will treat the absence of a token as "captcha disabled" too.
 */

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptPromise = null;

function loadScript() {
  if (!SITE_KEY) return Promise.resolve(false);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    if (window.grecaptcha?.ready) return resolve(true);
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return scriptPromise;
}

/**
 * Execute reCAPTCHA v3 and return the token (or null if disabled / failed).
 * Safe to call without awaiting — never throws, never blocks the caller.
 */
export async function getCaptchaToken(action) {
  if (!SITE_KEY) return null;
  try {
    const loaded = await loadScript();
    if (!loaded) return null;
    return await new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(SITE_KEY, { action })
          .then((token) => resolve(token))
          .catch(() => resolve(null));
      });
    });
  } catch (_e) {
    return null;
  }
}
